import React from "react";
import { PropTypes } from "prop-types";
import { MrbPage, MrbPageHeader } from "mrb/components/layout";
import { defaultTemplate } from "common/hoc";
import { LoadioConfigurationMasterPasswordEdit } from "administration/loadio/components";

function LoadioConfigurationTemplate({ loadioConfigurationViewStore, t }) {
    return (
        <MrbPage store={loadioConfigurationViewStore} t={t}>
            <MrbPageHeader>
                <div>{t("ADMINISTRATION.LOADIO.CONFIGURATION.TITLE")}</div>
            </MrbPageHeader>
            <div className="">
                <LoadioConfigurationMasterPasswordEdit
                    loadioConfigurationViewStore={loadioConfigurationViewStore}
                    t={t}
                />
            </div>
        </MrbPage>
    );
}

LoadioConfigurationTemplate.propTypes = {
    loadioConfigurationViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(LoadioConfigurationTemplate);
